import type { ProjectMeta } from '@/services/ProjectsService/types'

export function isMovie(projectMeta: Pick<ProjectMeta, 'projectType'>): boolean {
  return projectMeta.projectType === 'movie'
}

export function isSeries(projectMeta: Pick<ProjectMeta, 'projectType'>): boolean {
  return projectMeta.projectType === 'series'
}

export function isPodcast(projectMeta: Pick<ProjectMeta, 'projectType'>): boolean {
  return projectMeta.projectType === 'podcast'
}
